var map = {
	"./book.svg": 599,
	"./dumbbells-exercise.svg": 757,
	"./money-bag.svg": 417,
	"./pizza-slice.svg": 863,
	"./present-box.svg": 5,
	"./volleyball-ball.svg": 746,
	"./wrench-screwdriver-crossed.svg": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;